import validate from "D:/tjtw/edu/education-web/node_modules/nuxt/dist/pages/runtime/validate.js";
import router_45global from "D:/tjtw/edu/education-web/middleware/router.global.js";
export const globalMiddleware = [
  validate,
  router_45global
]
export const namedMiddleware = {}